const config = require("config");

(function () {
  "use strict";

  angular
    .module("alk.routeExceptions")
    .service("routeExceptionService", RouteExceptionService);

  RouteExceptionService.$inject = [
    "$http",
    "$q",
    "UserProvider",
    "alkLinkMappingService"
  ];

  function RouteExceptionService($http, $q, UserProvider, alkLinkMappingService) {
    var CLOSURE_SET_NAME = "Closures";
    var CLOSURE_OLD_NAME = "Closure_Default_rc";

    return {
      //  route exception set API
      getRouteExceptionSets: getRouteExceptionSets,
      createNewRouteExceptionSet: createNewRouteExceptionSet,
      deleteRouteExceptionSet: deleteRouteExceptionSet,
      updateRouteExceptionSet: updateRouteExceptionSet,
      getRouteExceptionSetByID: getRouteExceptionSetByID,
      moveRouteExceptions: moveRouteExceptions,
      tryCreateClosureSet: tryCreateClosureSet,
      getClosureSet: getClosureSet,

      //  route exception group API
      getGroupsForSet: getGroupsForSet,
      deleteGroup: deleteGroup,
      deleteMultipleGroups: deleteMultipleGroups,
      updateGroup: updateGroup,
      addNewLinksToGroup: addNewLinksToGroup,
      moveGroup: moveGroup,
      moveMultipleGroups: moveMultipleGroups,
      createGroup: createGroup,

      deleteAvoidFavors: deleteAvoidFavors,

      //  individual route exception API
      deleteRouteException: deleteRouteException,
      deleteRouteExceptions: deleteRouteExceptions,
      getRouteException: getRouteException,

      //  route exception groups
      createNewRouteExceptionGroup: createNewRouteExceptionGroup,

      //  misc
      CLOSURE_SET_NAME: CLOSURE_SET_NAME,
      CLOSURE_OLD_NAME: CLOSURE_OLD_NAME,
      UNNAMED_EXCEPTION: "Unnamed",
      AVOID: 1,
      FAVOR: 2,
      CLOSURE: 3
    };

    ////////////////
    //  route exception set API

    function getRouteExceptionSetByID(setID, detail = false) {
      return _getRouteExceptionSet(setID, detail, null)
        .then(function (resp) {
          if (resp.errors.length > 0) {
            return resp;
          }

          resp.data = _.head(resp.data);
          return resp;
        });
    }

    function getRouteExceptionSets(detail = false, filter = null) {
      return _getRouteExceptionSet(-1, detail, filter);
    }

    function getClosureSet() {
      let params = {
        "detail": false,
        "name": CLOSURE_OLD_NAME
      };

      let request = {
        method: "GET",
        url: config.pcmwsUrl + "AvoidFavorSets/-1",
        params: params
      };

      return _submitRequest(request)
        .then(function (resp) {
          if (resp.errors.length > 0) {
            return resp;
          }

          resp.data = _.head(resp.data);
          _.set(resp.data, "Name", CLOSURE_SET_NAME);
          return resp;
        });
    }

    //  setToCreate should be an object like
    //  {
    //    "Name:" xxx,
    //    "Tag":  xxx,
    //    "Links": [],
    //    "DataVersion": xxx,
    //    "SetType": 1 or 2
    //  }
    //  "SetType" = 1 is an AvoidFavor set.
    //  "SetType" = 2 is a Closure set.
    //  TODO:
    //  require set name,
    function createNewRouteExceptionSet(setToCreate) {
      let request = {
        method: "POST",
        url: config.pcmwsUrl + "AvoidFavorSets",
        params: {
          name: setToCreate.Name,
          tag: setToCreate.Tag
        }
      };

      return _submitRequest(request);
    }

    function tryCreateClosureSet() {
      return createNewRouteExceptionSet({
        Name: CLOSURE_OLD_NAME
      });
    }

    function deleteRouteExceptionSet(setID) {
      let request = {
        method: "DELETE",
        url: config.pcmwsUrl + "AvoidFavorSets/" + setID,
      };

      return _submitRequest(request);
    }

    function getRouteException(setID, exceptionID) {
      getRouteExceptionSetByID(setID)
        .then((resp) => {
          var exceptions = _.at(resp, ["data.Links"]);
          if (!exceptions)
            return null;

          return _.find(exceptions, {
            "AvoidFavorID": exceptionID
          });
        });
    }

    function updateRouteExceptionSet(setToUpdate) {
      let request = {
        method: "PUT",
        url: config.pcmwsUrl + "AvoidFavorSets/" + setToUpdate.SetID,
        params: {
          name: setToUpdate.Name,
          tag: setToUpdate.Tag
        }
      };

      return _submitRequest(request);
    }

    function moveRouteExceptions(sourceSet, destinationSetId) {
      let request = {
        method: "PUT",
        url: config.pcmwsUrl + "AvoidFavorSets/" + sourceSet.SetID,
        params: {
          name: sourceSet.Name,
          tag: sourceSet.Tag,
          destinationSetId: destinationSetId
        }
      };

      return _submitRequest(request);
    }

    ////////////////
    //  route exception group API

    function getGroupsForSet(setID, detail = false, filter = "") {
      let request = {
        url: config.pcmwsUrl + "AvoidFavorSets/" + setID + "/Groups",
        method: "GET",
        params: {
          detail: detail,
          filter: filter
        }
      };

      return _submitRequest(request);
    }

    function deleteGroup(setID, groupID) {
      let request = {
        url: config.pcmwsUrl + "AvoidFavorSets/" + setID + "/Group/" + groupID,
        method: "DELETE"
      };

      return _submitRequest(request);
    }

    function deleteMultipleGroups(setID, groupIDs = []) {
      if (groupIDs.length === 0) {
        var deferred = $q.defer();
        deferred.resolve({
          errorCode: 0,
          data: null
        });
        return deferred.promise;
      }

      let request = {
        url: config.pcmwsUrl + "AvoidFavorSets/" + setID + "/Groups",
        method: "DELETE",
        data: _.map(groupIDs, (i) => parseInt(i)),
        headers: {
          "Content-Type": "application/json; charset=utf-8"
        }
      };

      return _submitRequest(request);
    }

    //  Group: {
    //    GroupName,
    //    GroupComments,
    //    AvoidFavorType
    //  }
    function updateGroup(setID, groupID, group) {
      let request = {
        url: config.pcmwsUrl + "AvoidFavorSets/" + setID + "/Group/" + groupID,
        method: "PUT",
        data: group
      };

      return _submitRequest(request);
    }

    function moveGroup(setID, destinationSetId, group) {
      let request = {
        url: config.pcmwsUrl + "AvoidFavorSets/" + setID + "/Group/" + group.GroupID,
        method: "PUT",
        params: {
          destinationSetId: destinationSetId
        },
        data: group
      };

      return _submitRequest(request);
    }

    function moveMultipleGroups(setID, destinationSetId, groups) {
      var firstGroup = _.head(groups);
      if (_.isUndefined(firstGroup)) {
        var deferred = $q.defer();
        deferred.resolve({
          errorCode: 0,
          data: null
        });
        return deferred.promise;
      }

      return moveGroup(setID, destinationSetId, firstGroup)
        .then((resp) => {
          if (resp.errors.length > 0) {
            return resp;
          }

          return moveMultipleGroups(setID, destinationSetId, _.tail(groups));
        });
    }

    function addNewLinksToGroup(setID, groupID, groupType, gridAndLinks = []) {
      if (gridAndLinks.length === 0) {
        var defer = $q.defer();
        defer.resolve({
          errorCode: 0
        });

        return defer.promise;
      }

      let data = {
        "afGridLinks": []
      };

      //  for each gridAndLink (of the form GRID|LINK), we need to create an AFLink
      //  object that we can send to PCMWS.
      var afGridLinks = _.map(gridAndLinks, (gl) => {
        var gridLink = _.map(gl.split("|"), (i) => parseInt(i));
        return {
          Type: groupType,
          Grid: gridLink[0],
          Link: gridLink[1],
          Comment: null
        };
      });

      data.afGridLinks = afGridLinks;

      let request = {
        method: "POST",
        url: config.pcmwsUrl + "AvoidFavorSets/" + setID + "/AvoidFavorGridLink",
        params: {
          groupID: groupID
        },
        data: data
      };

      return _submitRequest(request);
    }

    function createGroup(setID, group) {
      let request = {
        url: config.pcmwsUrl + "AvoidFavorSets/" + setID + "/Groups",
        method: "POST",
        data: group
      };

      return _submitRequest(request);
    }

    function deleteAvoidFavors(setID, ids = []) {
      if (ids.length === 0) {
        var deferred = $q.defer();
        deferred.resolve({
          errorCode: 0,
          data: null
        });
        return deferred.promise;
      }

      let request = {
        url: config.pcmwsUrl + "AvoidFavorSets/" + setID + "/AvoidFavors",
        method: "DELETE",
        data: _.map(ids, (i) => parseInt(i)),
        headers: {
          "Content-Type": "application/json; charset=utf-8"
        }
      };

      return _submitRequest(request);
    }

    ////////////////
    //  individual route exception set API

    function deleteRouteException(setID, routeExceptionID) {
      let request = {
        method: "DELETE",
        url: config.pcmwsUrl + "AvoidFavorSets/" + setID + "/AvoidFavor/" + routeExceptionID
      };

      return _submitRequest(request);
    }

    function deleteRouteExceptions(setID, routeExceptionIDs) {
      let request = {
        method: "DELETE",
        url: config.pcmwsUrl + "AvoidFavorSets/" + setID + "/avoid-favors?afIds=" + routeExceptionIDs.toString()
      };

      return _submitRequest(request);
    }

    function createNewRouteExceptionGroup(gridAndLinks, groupType, groupName, setID, dataset) {
      let data = {
        "afGridLinks": []
      };

      //  for each gridAndLink (of the form GRID|LINK), we need to create an AFLink
      //  object that we can send to PCMWS.
      var afGridLinks = _.map(gridAndLinks, (gl) => {
        var gridLink = _.map(gl.split("|"), (i) => parseInt(i));
        return {
          Type: groupType,
          Grid: gridLink[0],
          Link: gridLink[1],
          Comment: groupName
        };
      });

      data.afGridLinks = afGridLinks;

      let request = {
        method: "POST",
        url: config.pcmwsUrl + "AvoidFavorSets/" + setID + "/AvoidFavorGridLink",
        params: {
          dataset: dataset,
          groupID: -1
        },
        data: data
      };

      return _submitRequest(request);
    }

    ////////////////
    //  internal helpers

    function _getRouteExceptionSet(setID, detail = false, filter = null) {
      let params = {
        // "onlyMine": false,
        "detail": detail,
        "plidOnly": false
      };

      if (!_.isNull(filter) && filter.trim() !== "") {
        params.name = filter;
        params.inexactNameMatch = true;
      }

      let request = {
        method: "GET",
        url: config.pcmwsUrl + "AvoidFavorSets/" + setID,
        params: params
      };

      var currentDataVersion = _.get(UserProvider.getUser(), "gridDataVersion");

      return alkLinkMappingService.dataVersionSupportsPLIDs(currentDataVersion)
        .then((dataVersionSupportsPLIDs) => {
          return _submitRequest(request)
            .then((resp) => {
              if (resp.errors.length > 0) {
                return resp;
              }

              //  rename the closure_default set at this point
              _.forEach(resp.data, (set) => {
                if (set.Name === CLOSURE_OLD_NAME)
                  set.Name = CLOSURE_SET_NAME;
              });

              //  lock sets
              _.forEach(resp.data, (set) => {
                set.locked = _shouldSetBeLocked(set, dataVersionSupportsPLIDs);
              });

              return resp;
            });
        });

      // return _submitRequest(request)
      //   .then((resp) => {
      //     if (resp.errors.length > 0) {
      //       return resp;
      //     }

      //     //  rename the closure_default set at this point
      //     _.forEach(resp.data, (set) => {
      //       if (set.Name === CLOSURE_OLD_NAME)
      //         set.Name = CLOSURE_SET_NAME;
      //     });

      //     return resp;
      //   });
    }

    function _shouldSetBeLocked(set, dataVersionAllowsPLIDs = false) {
      //  in order to determine if a set should be locked:
      //  1. the set must have links
      //  2. there must be a link without PLIDs
      //  3. the current data version must have PLID support

      //  1.  check if we have links
      if (_.isNull(set.Links) || set.Links.length === 0) {
        return false;
      }

      //  2.  check if there is a link without PLID data
      var hasNonPLIDData = _.some(set.Links, (link) => _.isNull(link.PLIDs) || link.PLIDs.length === 0);

      //  3.  check if current data version allows PLIDs
      return dataVersionAllowsPLIDs && hasNonPLIDData;
    }

    function _submitRequest(request) {
      var mapDataVersion = UserProvider.getUser().dataVersion || "Current";

      //  add a dataset parameter to our query params if it doesn't exist.
      _.set(request, ["params", "dataset"], mapDataVersion);

      return $http(request)
        .then(function (response) {
          return {
            errors: [],
            data: response.data
          };
        }, function (response) {
          if (!response || !response.data) {
            return {
              errors: [
                "Something unexpected happened."
              ],
              data: null
            };
          }

          return {
            errors: _.map(response.data, "Description"),
            data: null
          };
        });
    }
  }
})();




// WEBPACK FOOTER //
// ./Common Javascript Files/AngularJS/alk-route-exceptions/alkRouteException.service.js